import { createApiClientLinks, type AppRouter } from "@onadssuper/api-client";
import { createTRPCClient } from "@trpc/client";
import { createTRPCContext, createTRPCOptionsProxy } from "@trpc/tanstack-react-query";
import type { QueryClient } from "@tanstack/react-query";
import { getWorkspaceId } from "./workspace-context";

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>();

export const trpcClient = createTRPCClient<AppRouter>({
  links: createApiClientLinks({ url: "/api/v1/trpc", getWorkspaceId }),
});

/** For route loaders/guards outside React (router context). */
export const createTrpcProxy = (queryClient: QueryClient) =>
  createTRPCOptionsProxy<AppRouter>({ client: trpcClient, queryClient });

export type TrpcProxy = ReturnType<typeof createTrpcProxy>;

/** Query keys that don't depend on the current workspace; everything else is dropped on switch. */
export const isGlobalQueryKey = (key: readonly unknown[]) => {
  const first = key[0];
  const path = Array.isArray(first)
    ? first.filter((part): part is string => typeof part === "string")
    : [];
  return (
    path[0] === "me" || path[0] === "system" || (path[0] === "invitations" && path[1] === "preview")
  );
};
